export default {"src":"/_next/static/media/money.0153e326.svg","height":105,"width":91,"blurWidth":0,"blurHeight":0};